module.exports = __webpack_public_path__ + "ss.f7e55b077e99bfcd07b6.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/ss.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/ss.svg
// module chunks = styles